exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.post-creator[data-v-047652a3] {\n  background-color: #fff;\n  padding: 15px 20px;\n}\n.product-discount-params .product[data-v-047652a3] {\n  width: 50%;\n}\n@media (max-width: 768px) {\n.product-discount-params .product[data-v-047652a3] {\n    width: 100%;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-047652a3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/standard/input/InputPost.vue
// module id = cVLk
// module chunks = 53